// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  display: flex;
}

ion-toolbar {
  display: flex;
  align-items: center;
}

ion-buttons {
  margin-left: 16px;
  height: auto;
}
ion-buttons ion-menu-button {
  width: 32px;
  height: 32px;
}
ion-buttons .home-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 4px;
}
ion-buttons.md {
  position: absolute;
}

ion-title {
  align-items: start;
}
ion-title img {
  padding-left: 40px;
}

.toolbar-background {
  background-color: transparent;
}

::ng-deep .header-background {
  background-color: var(--vl-red);
  max-height: var(--ion-safe-area-top, 0);
  position: relative;
}

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-wrapper .right-block {
  display: flex;
  align-items: center;
}
.title-wrapper .right-block .verify-block {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 1rem;
}
.title-wrapper .right-block .verify-block .warning-text {
  font-size: 0.9rem;
  color: #ff8f14;
}
.title-wrapper .right-block .verify-block .warning-icon {
  vertical-align: text-bottom;
  color: #ff8f14;
  font-size: 1.3rem;
}
.title-wrapper .right-block .username-lang {
  display: flex;
  align-items: center;
}
.title-wrapper .right-block .username-lang .lang-wrapper {
  display: inherit;
  align-items: center;
  font-size: 16px;
  padding-right: 40px;
  color: white;
}
.title-wrapper .right-block .username-lang .lang-wrapper .lang {
  cursor: pointer;
}
.title-wrapper .right-block .username-lang .lang-wrapper .lang:first-child {
  border-right: 1px solid white;
  padding-right: 5px;
}
.title-wrapper .right-block .username-lang .lang-wrapper .lang:last-child {
  padding-left: 5px;
}
.title-wrapper .right-block .username-lang .lang-wrapper .active {
  color: var(--vl-red);
}
.title-wrapper .right-block .username-lang .username {
  font-size: 16px;
  color: white;
}
.title-wrapper .right-block .username-lang .btn {
  border-radius: 27px;
  border: 1px solid white;
  padding: 10px 20px;
}

vl-icon {
  color: white;
}

@media (max-width: 576px) {
  .username-lang .lang-wrapper, .username-lang .username, .username-lang .verify-block, .username-lang vl-language-switcher {
    display: none !important;
  }
}
@media (max-width: 768px) {
  .toolbar-logo {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,YAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;AAEE;EACE,kBAAA;AAAJ;;AAIA;EACE,6BAAA;AADF;;AAKE;EACE,+BAAA;EACA,uCAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAHF;AAIE;EACE,aAAA;EACA,mBAAA;AAFJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AADN;AAEM;EACE,iBAAA;EACA,cAAA;AAAR;AAEM;EACE,2BAAA;EACA,cAAA;EACA,iBAAA;AAAR;AAII;EACE,aAAA;EACA,mBAAA;AAFN;AAGM;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AADR;AAEQ;EACE,eAAA;AAAV;AAEQ;EACE,6BAAA;EACA,kBAAA;AAAV;AAEQ;EACE,iBAAA;AAAV;AAEQ;EACE,oBAAA;AAAV;AAGM;EACE,eAAA;EACA,YAAA;AADR;AAGM;EACE,mBAAA;EACA,uBAAA;EACA,kBAAA;AADR;;AAOA;EACE,YAAA;AAJF;;AAOA;EAEI;IACE,wBAAA;EALJ;AACF;AASA;EACE;IACE,aAAA;EAPF;AACF","sourcesContent":["ion-header{\n  display: flex;\n}\n\nion-toolbar {\n  display: flex;\n  align-items: center;\n}\n\nion-buttons {\n  margin-left: 16px;\n  height: auto;\n  ion-menu-button {\n    width: 32px;\n    height: 32px;\n  }\n\n  .home-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    margin-left: 4px;\n  }\n\n  &.md {\n    position: absolute;\n  }\n}\n\nion-title {\n  align-items: start;\n  img {\n    padding-left: 40px;\n  }\n}\n\n.toolbar-background {\n  background-color: transparent;\n}\n\n::ng-deep {\n  .header-background {\n    background-color: var(--vl-red);\n    max-height: var(--ion-safe-area-top, 0);\n    position: relative;\n  }\n}\n\n.title-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .right-block{\n    display: flex;\n    align-items: center;\n    .verify-block{\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      margin-left: 1rem;\n      .warning-text{\n        font-size: 0.9rem;\n        color: #ff8f14;\n      }\n      .warning-icon{\n        vertical-align: text-bottom;\n        color: #ff8f14;\n        font-size: 1.3rem;\n      }\n    }\n\n    .username-lang {\n      display: flex;\n      align-items: center;\n      .lang-wrapper {\n        display: inherit;\n        align-items: center;\n        font-size: 16px;\n        padding-right: 40px;\n        color: white;\n        .lang {\n          cursor: pointer;\n        }\n        .lang:first-child {\n          border-right: 1px solid white;\n          padding-right: 5px;\n        }\n        .lang:last-child {\n          padding-left: 5px;\n        }\n        .active {\n          color: var(--vl-red);\n        }\n      }\n      .username {\n        font-size: 16px;\n        color: white;\n      }\n      .btn {\n        border-radius: 27px;\n        border: 1px solid white;\n        padding: 10px 20px;\n      }\n    }\n  }\n}\n\nvl-icon {\n  color: white;\n}\n\n@media (max-width: 576px) {\n  .username-lang {\n    .lang-wrapper, .username, .verify-block, vl-language-switcher {\n      display: none !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .toolbar-logo{\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
